import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedDownloadURLForStatsRPC } from "./getPresignedDownloadUrlForStatsRPC";

export class GetPresignedDownloadURLForStatsRPCClientImpl extends GetPresignedDownloadURLForStatsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedDownloadURLForStatsRPC.Request): Promise<LeoRPCResult<GetPresignedDownloadURLForStatsRPC.Response, GetPresignedDownloadURLForStatsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/GetPresignedDownloadURLForStats",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedDownloadURLForStatsRPC.ResponseDTO,
      GetPresignedDownloadURLForStatsRPC.Errors.ErrorsDTO,
      GetPresignedDownloadURLForStatsRPC.Response,
      GetPresignedDownloadURLForStatsRPC.Errors.Errors
    >(
      response,
      "email-cycle/GetPresignedDownloadURLForStats",
      GetPresignedDownloadURLForStatsRPC.Response.fromDTO,
      GetPresignedDownloadURLForStatsRPC.Errors.fromDTO
    );
  }
}
